import api from './index'
import { axios } from '@/utils/request'

//  系统管理员（即平台管理员）管理用户数据，包括获取用户数据列表、更新用户数据、重置用户密码、删除用户、创建用户

//  以下为获取整个系统注册用户的列表
export function getItemList (parameter) {
  return axios({
    url: api.GetItemList,
    method: 'get',
    params: parameter
  })
}

//  以下为更新整个用户的信息，除了用户密码意外的其它信息都需要更新，管理员对用户密码只能做重置操作
export function updateUserInfo (parameter) {
  return axios({
    url: api.UpdateUser,
    method: 'put',
    params: parameter
  })
}

// 以下为创建一个新用户的方法，发送的请求体为用户的基本信息，但其中不包括用户密码，
// 管理员创建的用户的初始密码为“123456”
export function createUser (params) {
  return axios({
    url: api.CreateUser,
    method: 'post',
    params: params
  })
}

// 以下为删除某一个用户的方法，只需要传输一个userUid即可
export function deleteUser (userUid) {
  return axios({
    url: api.DeleteUser + '/' + userUid,
    method: 'delete'
  })
}

// 以下为重置某一个用户的密码的方法
export function resetPwd (params) {
  return axios({
    url: api.ResetPwd,
    method: 'post',
    params: params
  })
}
